import { useEffect } from 'react';
import { toast } from 'sonner';

export function SWUpdatePrompt({ registration }) {
  useEffect(() => {
    if (!registration) return;

    const handleUpdate = () => {
      const waitingWorker = registration.waiting;
      if (waitingWorker) {
        waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    };

    toast.info('Nova versão disponível!', {
      description: 'Clique em Atualizar para aplicar a nova versão.',
      duration: Infinity,
      action: {
        label: 'Atualizar',
        onClick: handleUpdate,
      },
    });
  }, [registration]);

  return null;
}
